import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useCreateSubscriptionAlertMutation } from 'api/main';
import { tunnelActions, userSelectors } from 'reducers';
import { getQueryParameter, parseFullName } from 'utils/helpers';
import { stepIDs } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { Box, Typography, Link } from '@mui/material';

const Abandonner = () => {
    const dispatch = useDispatch();

    const [createSubscriptionAlert] = useCreateSubscriptionAlertMutation();

    const internalUser = useSelector(userSelectors.getInternalUser);
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);
    const subscriptionAlerts = useMemo(
        () =>
            tunnelSubscription?.userTunnelSteps?.reduce((acc, crt) => {
                if (
                    crt.tunnelStep.step.id !== stepIDs.ID_CHECK &&
                    crt.tunnelStep.step.id !== stepIDs.SECOND_ID_CHECK &&
                    crt.tunnelStep.step.id !== stepIDs.ADDRESS_CHECK &&
                    crt.tunnelStep.step.id !== stepIDs.RIB_CHECK
                ) {
                    return acc.concat(crt.alerts.filter(a => a.blocking && !a.solved));
                }
                return acc;
            }, []),
        [tunnelSubscription]
    );

    useEffect(() => {
        dispatch(tunnelActions.setIneligible({}));
    }, [dispatch]);

    useEffect(() => {
        const userStepId = getQueryParameter(window.location.search, 'userStepId');
        // make sure it's an ongoing subscription
        // this will prevent this effect running again after stopping an impersonation session before redirecting
        if (userStepId && tunnelSubscription) {
            const abandonAlert = subscriptionAlerts?.find(
                a => a.message === 'ABANDONED_STEP' && a.solved === false
            );
            if (!abandonAlert) {
                const payload = {
                    type: 'critical',
                    message: 'ABANDONED_STEP',
                    alertCode: 15,
                    userTunnelStep: `/api/user_tunnel_steps/${userStepId}`,
                    displayedToUser: false,
                };
                createSubscriptionAlert(payload);
            }
        }
    }, [createSubscriptionAlert, subscriptionAlerts, tunnelSubscription]);

    return (
        <Box
            sx={theme => ({
                // paddingTop: `${theme.constants.appBarHeight}px`,
                width: '100%',
                flex: '1 1',
            })}
        >
            <Box sx={{ marginTop: '30px', padding: '0 20px' }}>
                <Typography variant="body1" component="p" align="center">
                    {texts.MERCI_DEBUT} {parseFullName(internalUser)} {texts.POUR_INTERET_1}{' '}
                    <Link underline="hover" href="mailto:contact@peqan.fr">
                        contact@peqan.fr
                    </Link>
                    {'.'}
                </Typography>
            </Box>
        </Box>
    );
};

export default Abandonner;
